module.exports = __webpack_public_path__ + "static/GatsbyIcon-cf3887e0e34a5150f10ff1c38bd7dfb4.png";